<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <v-row>
      <v-col cols="12">
        <v-autocomplete v-model="statusTarefaSelecionada" :items="listaStatusTarefa" label="Filtrar por Status:" autocomplete="off" clearable></v-autocomplete>
      </v-col>
    </v-row>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Tarefas'"
      :newRowmodalButtonText="'Nova tarefa'"
      :tableHeader="headers"
      :tableRows="tarefas"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      :isReport="true"
      :totalItens="total"
      v-on:datatable-newrow="onDataTableInsertRow"
      v-on:datatable-updaterow="onDataTableUpdateRow"
      v-on:datatable-deleterow="onDataTableDeleteRow"
      v-on:datatable-report="abrirModalGerarRelatorio"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable v-show="showSkeletonTable == true" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <ModalCustomSize
      :modalSize="modalCustomSizeData.modalSize"
      :isTheModalOpen="modalCustomSizeData.isOpen"
      :modalButtonText="modalCustomSizeData.buttonText"
      :modalFormTitle="modalCustomSizeData.formTitle"
      :modalType="modalCustomSizeData.modalType"
      :isLoadingRequestDisable="modalCustomSizeData.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSizeData.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSizeData.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSizeData.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-form v-model="estaValido">
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>

        <v-row v-if="modalCustomSizeData.isView && !modalCustomSizeData.isEdit">
          <v-col>
            <v-list>
              <v-list-item>
                <v-list-item-action>
                  <v-checkbox v-model="todosSelecionado" @click="selecionaTodos"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>Listar todos</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-for="(setor, i) in modalCustomSizeData.relatorio.listaSetores" :key="i">
                <v-list-item-action>
                  <v-checkbox v-model="modalCustomSizeData.relatorio.listaDeSetoresParaGerar" :value="setor" @click="seleciona"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title v-text="setor.setor.nomeSetor"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12">
            <v-autocomplete label="Empresas" :items="empresas" :rules="empresaRules" @change="enderecoEmpresaSelecionado = null" v-model="empresaSelecionada" name="numeroEmpresa" autocomplete="off"></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-autocomplete label="Endereços" :items="enderecoEmpresa" :rules="enderecoRules" v-model="enderecoEmpresaSelecionado" name="numeroEndereco" autocomplete="off"></v-autocomplete>
          </v-col>

          <!-- Empresa -->
          <v-col cols="4" v-if="this.enderecoEmpresaSelecionado != null">
            <v-text-field v-model="infoEnderecoEmpresa.nomeFantasia" disabled label="Nome do Responsável" autocomplete="off"></v-text-field>
          </v-col>
          <v-col cols="4" v-if="this.enderecoEmpresaSelecionado != null">
            <v-text-field v-model="infoEnderecoEmpresa.endereco" disabled label="Endereço" autocomplete="off"></v-text-field>
          </v-col>
          <v-col cols="4" v-if="this.enderecoEmpresaSelecionado != null">
            <v-text-field v-model="infoEnderecoEmpresa.cep" disabled label="CEP" autocomplete="off"></v-text-field>
          </v-col>

          <v-col cols="4" v-if="this.enderecoEmpresaSelecionado != null">
            <v-text-field v-model="infoEnderecoEmpresa.numero" disabled label="Numero" autocomplete="off"></v-text-field>
          </v-col>
          <v-col cols="4" v-if="this.enderecoEmpresaSelecionado != null">
            <v-text-field v-model="infoEnderecoEmpresa.cevs" disabled label="CEVS" autocomplete="off"></v-text-field>
          </v-col>
          <v-col cols="4" v-if="this.enderecoEmpresaSelecionado != null">
            <v-text-field v-model="infoEnderecoEmpresa.icStatus" disabled label="Status do CEVS" autocomplete="off"></v-text-field>
          </v-col>
          <!-- Empresa -->

          <v-col cols="6">
            <v-autocomplete label="Nome do Fiscal" :items="usuarios" v-model="modalCustomSizeData.actualEdit.numeroUsuario" name="numeroUsuario" autocomplete="off"></v-autocomplete>
          </v-col>

          <v-col cols="6">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="dateFormatted" label="Data Prazo" :rules="dataRules" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-mask="['##/##/####']" @blur="date = parseDate(dateFormatted)" v-on="on" autocomplete="off"></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title @input="menu = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12">
            <v-autocomplete label="Roteiros" :items="roteiros" :rules="roteiroRules" v-model="modalCustomSizeData.actualEdit.numeroRoteiro" name="numeroRoteiro" autocomplete="off"></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>

    <Carregando :habilitar="carregando.habilitar" :texto="carregando.texto"> </Carregando>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import { Document, Packer, Paragraph, ShadingType, TextRun, Header, AlignmentType, PageNumber, BorderStyle, WidthType } from "docx";
import * as fs from "file-saver";
import Carregando from "../components/Carregando";

export default {
  components: {
    DataTable,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal,
    Carregando,
  },

  sockets: {
    reciveInsert: function(data) {
      if (data.descricaoTela == "sincronizarTarefa") {
        if (data.tarefa.tipoTarefa == 0) {
          this.alertaSocket.texto = "Tarefa do numero: " + data.tarefa.numeroTarefa + " foi respondida.";
          this.alertaSocket.tipo = "info";
          this.initialize();
        }

        if (data.tarefa.tipoTarefa == 2) {
          this.alertaSocket.texto = "Retorno do numero: " + data.tarefa.numeroTarefa + " foi respondida.";
          this.alertaSocket.tipo = "info";
          this.initialize();
        }
      }
    },
  },

  data: (vm) => ({
    //Paginação
    page: 1,
    search: null,
    total: null,
    //Fim da paginação

    // Alertas
    alerta: {
      texto: "",
      tipo: "",
    },
    alertaSocket: {
      texto: "",
      tipo: "",
    },
    alertaModal: {
      texto: "",
      tipo: "",
    },

    // Input de data
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu: false,

    // Outros
    showSkeletonTable: true,
    estaValido: false,
    rowPosition: 0,

    //Carregando para requests
    carregando: {
      habilitar: false,
      texto: "Por favor aguarde um momento...",
    },

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID",
        value: "tarefa.numeroTarefa",
      },
      {
        text: "Usuario",
        value: "usuario.nomeUsuario",
      },
      {
        text: "Roteiro",
        value: "roteiro.nomeRoteiro",
      },
      {
        text: "Data Criação",
        value: "tarefa.dataCriacaoTarefa",
      },
      {
        text: "Data Conclusão",
        value: "tarefa.dataConclusaoTarefa",
      },
      {
        text: "Status",
        value: "tarefa.statusTarefa",
      },
      {
        text: "Tipo",
        value: "tarefa.tipoTarefa",
      },
      {
        text: "Empresa",
        value: "empresa.nomeFantasia",
      },
      { text: "Atualizar/Excluir", value: "actions", sortable: false },
    ],

    empresaRules: [(v) => !!v || "Empresa é obrigatório"],
    enderecoRules: [(v) => !!v || "Endereco é obrigatório"],
    fiscalRules: [(v) => !!v || "Fiscal é obrigatório"],
    dataRules: [(v) => !!v || "Data é obrigatório", (v) => (v && v.length >= 10) || "Data contém um formato invalido"],
    roteiroRules: [(v) => !!v || "Roteiro é obrigatório"],

    modalCustomSizeData: {
      modalSize: "1100",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroTarefa: null,
        numeroEmpresa: null,
        numeroEndereco: null,
        numeroUsuario: null,
        numeroRoteiro: null,
        tipoTarefa: 0,
        statusTarefa: 0,
        dataTarefa: null,
        descricaoTela: "tarefas",
      },
      relatorio: {
        razaoSocial: null,
        nomeFantasia: null,
        nomeResponsavel: null,
        cnpj: null,
        cevs: null,
        endereco: null,
        bairro: null,
        nomeRoteiro: null,
        descricaoRoteiro: null,
        testemunhasTarefa: [],
        listaSetores: [],
        listaDeSetoresParaGerar: [],
        descricaoTela: "tarefasAgente",
      },
    },

    infoEnderecoEmpresa: {
      nomeFantasia: null,
      endereco: null,
      cep: null,
      numero: null,
      cevs: null,
      icStatus: null,
    },

    //CONFIG PARA MANDAR EM UM REQUEST
    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    //Array populado pela função initialize
    tarefas: [],
    roteiros: [],
    usuarios: [],
    empresas: [],
    enderecoEmpresa: [],
    listarEndereco: [],

    roteiroSelecionado: null,
    usuarioSelecionado: null,
    empresaSelecionada: null,
    enderecoEmpresaSelecionado: null,

    statusTarefaSelecionada: null,
    listaStatusTarefa: [
      {
        text: "Em Andamento",
        value: 0,
      },
      {
        text: "Adiado",
        value: 2,
      },
      {
        text: "Processo Aberto",
        value: 4,
      },
      {
        text: "Concluída",
        value: 1,
      },
      // {
      //   text: "Concluída",
      //   value: 3,
      // },
      {
        text: "Concluída com Atraso",
        value: 5,
      },
    ],

    rules: {
      required: (value) => value.length > 0 || "Requer o campo!",
    },
  }),

  created() {
    this.initialize();
  },

  watch: {
    empresaSelecionada() {
      if (this.empresaSelecionada != null) {
        this.modalCustomSizeData.actualEdit.numeroEmpresa = this.empresaSelecionada; //POPULA numeroEmpresa para mandar pro back
        this._listarEnderecoEmpresas();
        this._listarRoteiros();
      }
    },

    enderecoEmpresaSelecionado() {
      if (this.enderecoEmpresaSelecionado != null) {
        this.modalCustomSizeData.actualEdit.numeroEndereco = this.enderecoEmpresaSelecionado; //POPULA numeroEndereco para mandar pro back
        this._listarEnderecoSelecionado();
      } else {
        this.infoEnderecoEmpresa.nomeFantasia = null;
        this.infoEnderecoEmpresa.endereco = null;
        this.infoEnderecoEmpresa.cep = null;
        this.infoEnderecoEmpresa.numero = null;
        this.infoEnderecoEmpresa.cevs = null;
        this.infoEnderecoEmpresa.icStatus = null;
      }
    },

    date() {
      this.dateFormatted = this.formatDate(this.date);
    },

    estaValido() {
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido;
    },

    statusTarefaSelecionada() {
      this._listarTarefasDetalhada();
    },
  },

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  methods: {
    /****************************************************************
     *                 FUNÇÕES DE EVENTO
     **************************************************************** */

    onDataTableInsertRow() {
      this.alertaModal.texto = null;
      this.alertaModal.tipo = null;

      this.modalCustomSizeData.isOpen = true;
      this.modalCustomSizeData.isEdit = false;
      this.modalCustomSizeData.isView = false;
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido;
      this.modalCustomSizeData.buttonText = "Registrar";
      this.modalCustomSizeData.formTitle = "Nova Tarefa";

      this.modalCustomSizeData.actualEdit.numeroTarefa = null;
      this.modalCustomSizeData.actualEdit.numeroEmpresa = null;
      this.modalCustomSizeData.actualEdit.numeroEndereco = null;
      this.modalCustomSizeData.actualEdit.numeroUsuario = null;
      this.modalCustomSizeData.actualEdit.numeroRoteiro = null;
      this.modalCustomSizeData.actualEdit.dataTarefa = null;
      this.empresaSelecionada = null;
      this.enderecoEmpresaSelecionado = null;
      this.roteiroSelecionado = null;
      this.date = null;
    },

    onDataTableUpdateRow(item) {
      this.alertaModal.texto = null;
      this.alertaModal.tipo = null;

      this.modalCustomSizeData.isOpen = true;
      this.modalCustomSizeData.isEdit = true;
      this.modalCustomSizeData.isView = false;
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido;
      this.modalCustomSizeData.buttonText = "Salvar";
      this.modalCustomSizeData.formTitle = "Atualizar Tarefa";

      this.modalCustomSizeData.actualEdit.numeroTarefa = item.tarefa.numeroTarefa;
      this.modalCustomSizeData.actualEdit.numeroEmpresa = item.empresa.numeroEmpresa;
      this.modalCustomSizeData.actualEdit.numeroEndereco = item.endereco.numeroEndereco;
      this.modalCustomSizeData.actualEdit.numeroUsuario = item.usuario.numeroUsuario;
      this.modalCustomSizeData.actualEdit.numeroRoteiro = item.roteiro.numeroRoteiro;
      this.modalCustomSizeData.actualEdit.dataTarefa = item.tarefa.dataTarefa;
      this.empresaSelecionada = item.empresa.numeroEmpresa;
      this.enderecoEmpresaSelecionado = item.endereco.numeroEndereco;
      this.roteiroSelecionado = item.roteiro.numeroRoteiro;
      this.date = this._formatStringInBrazilianDateFormat(this.modalCustomSizeData.actualEdit.dataTarefa);
    },

    async abrirModalGerarRelatorio(tarefaSelecionada) {
      try {
        this.alertaModal.tipo = null;
        this.dialog = true;

        let tarefaRespondida = await axios.put("tarefaRespondida", tarefaSelecionada.tarefa, this.config);

        this.modalCustomSizeData.relatorio.telefoneEmpresa = tarefaSelecionada.empresa.telefone;
        this.modalCustomSizeData.relatorio.emailEmpresa = tarefaSelecionada.empresa.email;
        this.modalCustomSizeData.relatorio.cepEndereco = tarefaSelecionada.endereco.cep;
        this.modalCustomSizeData.relatorio.dataInicio = this.formatDate(this.formataDataBanco(tarefaRespondida.data.tarefa.dataCriacaoTarefa));
        this.modalCustomSizeData.relatorio.dataFim = this.formatDate(this.formataDataBanco(tarefaRespondida.data.tarefa.dataConclusaoTarefa));

        this.modalCustomSizeData.relatorio.razaoSocial = tarefaRespondida.data.empresa.razaoSocial;
        this.modalCustomSizeData.relatorio.nomeFantasia = tarefaRespondida.data.empresa.nomeFantasia;
        this.modalCustomSizeData.relatorio.nomeResponsavel = tarefaRespondida.data.endereco.nomeResponsavel;
        this.modalCustomSizeData.relatorio.cnpj = tarefaRespondida.data.empresa.cnpj;
        this.modalCustomSizeData.relatorio.cevs = tarefaRespondida.data.endereco.cevs;
        this.modalCustomSizeData.relatorio.endereco = tarefaRespondida.data.endereco.endereco;
        this.modalCustomSizeData.relatorio.bairro = tarefaRespondida.data.endereco.bairro;
        this.modalCustomSizeData.relatorio.nomeRoteiro = tarefaRespondida.data.roteiro.nomeRoteiro;
        this.modalCustomSizeData.relatorio.descricaoRoteiro = tarefaRespondida.data.roteiro.descricaoRoteiro;
        this.modalCustomSizeData.relatorio.listaSetores = tarefaRespondida.data.listaSetores;
        this.modalCustomSizeData.relatorio.listaDeSetoresParaGerar = [];
        this.modalCustomSizeData.relatorio.testemunhasTarefa = tarefaSelecionada.testemunhaTarefa;
        this.todosSelecionado = false;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.dialog = false;
      } finally {
        this.modalCustomSizeData.isOpen = true;
        this.modalCustomSizeData.isEdit = false;
        this.modalCustomSizeData.isView = true;
        this.modalCustomSizeData.isButtonsVisible = true;
        this.modalCustomSizeData.buttonText = "Gerar";
        this.modalCustomSizeData.formTitle = "Gerar Relatório de Tarefa";

        this.dialog = false;
      }
    },

    async onDataTableDeleteRow(item) {
      try {
        await this.delete(item);
      } catch (error) {
        console.log(error);
      } finally {
        await this._listarTarefasDetalhada();
      }
    },

    async onFormModalAction() {
      try {
        this.modalCustomSizeData.isButtonsDisabled = true;
        if (this.modalCustomSizeData.isEdit && !this.modalCustomSizeData.isView) {
          await this.update(this.modalCustomSizeData.actualEdit);
        } else if (!this.modalCustomSizeData.isEdit && this.modalCustomSizeData.isView) {
          await this.gerarRelatorio();
        } else {
          await this.insert(this.modalCustomSizeData.actualEdit);
        }
      } catch (error) {
        this.mensagemErro = error.response.data.message;
      } finally {
        await this._listarTarefasDetalhada();
        this.modalCustomSizeData.isOpen = false;
        this.modalCustomSizeData.isButtonsDisabled = false;
      }
    },

    /****************************************************************
     *                 FUNÇÕES DO COMPONENTE
     **************************************************************** */
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    async _listarTarefasDetalhada() {
      try {
        const response = await axios.put("tarefaDetalhada", { statusTarefa: this.statusTarefaSelecionada, page: this.page, search: this.search }, this.config);
        if (!response.data || response.data.length > 0) {
          this.tarefas = response.data;
          this.total = response.data[0].total;
        }
        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateSearch(search) {
      if (search) {
        this.search = search;
        this.page = 1;
        await this._listarTarefasDetalhada();
      } else {
        this.page = 1;
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page;
      await this._listarTarefasDetalhada();
    },

    async _listarRoteiros() {
      try {
        const numeroEmpresaObjeto = { numeroEmpresa: this.empresaSelecionada };
        const responseCnaeEmpresa = await axios.post("cnaePorEmpresa", numeroEmpresaObjeto, this.config);

        const response = await axios.put("roteiroPorCnae", responseCnaeEmpresa.data, this.config);

        this.roteiros = response.data.map(function(roteiroSelecionado) {
          return {
            text: roteiroSelecionado.nomeRoteiro,
            value: roteiroSelecionado.numeroRoteiro,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async _listarUsuarios() {
      try {
        const response = await axios.get("usuarios", this.config);

        this.usuarios = response.data.map(function(usuarioSelecionado) {
          return {
            text: usuarioSelecionado.nomeUsuario,
            value: usuarioSelecionado.numeroUsuario,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async _listarEmpresas() {
      try {
        const response = await axios.get("empresa", this.config);

        this.empresas = response.data.map(function(empresaSelecionada) {
          return {
            text: empresaSelecionada.nomeFantasia,
            value: empresaSelecionada.numeroEmpresa,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async _listarEnderecoEmpresas() {
      try {
        const response = await axios.put("enderecoEmpresa", this.modalCustomSizeData.actualEdit, this.config);

        this.enderecoEmpresa = response.data.map(function(enderecoEmpresaSelecionado) {
          return {
            value: enderecoEmpresaSelecionado.endereco.numeroEndereco,
            text: enderecoEmpresaSelecionado.endereco.endereco + " - " + enderecoEmpresaSelecionado.endereco.cevs,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async _listarEnderecoSelecionado() {
      try {
        const response = await axios.put("selecionarEndereco", this.modalCustomSizeData.actualEdit, this.config);

        this.listarEndereco = response.data;

        //POPULA INFORMAÇÕES DO ENDERECO
        this.infoEnderecoEmpresa.nomeFantasia = this.listarEndereco.nomeResponsavel;
        this.infoEnderecoEmpresa.endereco = this.listarEndereco.endereco;
        this.infoEnderecoEmpresa.cep = this.listarEndereco.cep;
        this.infoEnderecoEmpresa.numero = this.listarEndereco.numero;
        this.infoEnderecoEmpresa.cevs = this.listarEndereco.cevs;
        if (this.listarEndereco.icStatus == 0) {
          this.infoEnderecoEmpresa.icStatus = "Endereço ATIVO";
        } else if (this.listarEndereco.icStatus == 1) {
          this.infoEnderecoEmpresa.icStatus = "Endereço INATIVO";
        }
      } catch (error) {
        console.log(error);
      }
    },

    async initialize() {
      try {
        await this._listarTarefasDetalhada();
        await this._listarUsuarios();
        await this._listarEmpresas();
        await this._listarEnderecoEmpresas();
      } catch (error) {
        console.log(error);
      }
    },

    async insert(reciveItem) {
      this.modalCustomSizeData.actualEdit.dataTarefa = this.date;
      this.modalCustomSizeData.isLoadingRequestDisable = true;
      try {
        this.alertaModal.tipo = null;
        await axios.post("tarefas", reciveItem, this.config);

        this.$socket.emit("insertApp", reciveItem);
        this.$socket.emit("insertLog");

        this.modalCustomSizeData.isLoadingRequestDisable = false;
        this.alerta.texto = "Tarefa criada com sucesso!";
        this.alerta.tipo = "sucesso";
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
        this.initialize();
      }
    },

    async update(reciveItem) {
      this.modalCustomSizeData.actualEdit.dataTarefa = this.date;
      this.modalCustomSizeData.isLoadingRequestDisable = true;

      try {
        this.alertaModal.tipo = null;
        await axios.put("tarefas", reciveItem, this.config);
        this.$socket.emit("insertLog");

        this.modalCustomSizeData.isLoadingRequestDisable = false;
        this.alerta.texto = "Tarefa atualizada com sucesso!";
        this.alerta.tipo = "sucesso";
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
        this.initialize();
      }
    },

    async delete(reciveItem) {
      try {
        if (confirm("Você realmente deseja excluir esta tarefa?")) {
          this.carregando.habilitar = true;
          reciveItem.descricaoTela = "tarefas";

          await axios.delete("tarefas", { data: reciveItem.tarefa, headers: this.config.headers });
          this.$socket.emit("insertLog");
          this.$socket.emit("insertApp", reciveItem);
          this.alerta.texto = "Tarefa removida com sucesso!";
          this.alerta.tipo = "sucesso";
          this.carregando.habilitar = false;

          return true;
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
        this.carregando.habilitar = false;
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
        this.carregando.habilitar = false;
        this.initialize();
      }
    },

    //#region DOCUMENTO
    gerarRelatorio() {
      const bordaParagrafo = {
        top: {
          color: "auto",
          space: 1,
          style: BorderStyle.SINGLE,
          size: 1,
          type: WidthType.DXA,
        },
        bottom: {
          color: "auto",
          space: 1,
          style: BorderStyle.SINGLE,
          size: 1,
          type: WidthType.DXA,
        },
        left: {
          color: "auto",
          space: 1,
          style: BorderStyle.SINGLE,
          size: 1,
          type: WidthType.DXA,
        },
        right: {
          color: "auto",
          space: 1,
          style: BorderStyle.SINGLE,
          size: 1,
          type: WidthType.DXA,
        },
      };

      let corpoDocx = {
        sections: [
          {
            properties: {
              titlePage: true,
            },
            headers: {
              default: new Header({
                children: [
                  new Paragraph({
                    alignment: AlignmentType.CENTER,
                    children: [new TextRun({ text: this.formatDate(new Date().toISOString().substr(0, 10)), bold: true }), new TextRun({ children: ["\t\t\t\t\t\t\t\t\t\tPág. ", PageNumber.CURRENT], bold: true })],
                    shading: {
                      type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                      color: "dadfe1",
                      fill: "dadfe1",
                    },
                  }),
                ],
              }),
            },
            children: [
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new TextRun({ text: this.formatDate(new Date().toISOString().substr(0, 10)), bold: true }), new TextRun({ text: "\t\t\tFICHA DE PROCEDIMENTO\t\t\t\t", bold: true }), new TextRun({ children: ["Pág. ", PageNumber.CURRENT], bold: true })],
                shading: {
                  type: ShadingType.HORIZONTAL_CROSS,
                  color: "dadfe1",
                  fill: "dadfe1",
                },
                spacing: {
                  after: 90,
                },
              }),

              //#region ESTABELECIMENTO
              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [new TextRun({ text: "IDENTIFICAÇÃO DO ESTABELECIMENTO", bold: true })],
                shading: {
                  type: ShadingType.HORIZONTAL_CROSS,
                  color: "dadfe1",
                  fill: "dadfe1",
                },
                spacing: {
                  before: 30,
                  after: 30,
                },
              }),
              new Paragraph({
                children: [
                  new TextRun({ text: "CNPJ/CPF: " }),
                  new TextRun({ text: this.modalCustomSizeData.relatorio.cnpj ? this.modalCustomSizeData.relatorio.cnpj : "", allCaps: true, size: 24, type: WidthType.DXA }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "Número de Cadastro - CEVS: " }),
                  new TextRun({ text: this.modalCustomSizeData.relatorio.cevs ? this.modalCustomSizeData.relatorio.cevs : "", allCaps: true, size: 24, type: WidthType.DXA }),
                ],
                spacing: {
                  after: 10,
                },
              }),
              new Paragraph({
                children: [new TextRun({ text: "Razão Social / Nome: " }), new TextRun({ text: this.modalCustomSizeData.relatorio.razaoSocial ? this.modalCustomSizeData.relatorio.razaoSocial : "", allCaps: true, size: 24, type: WidthType.DXA })],
                spacing: {
                  after: 60,
                },
              }),

              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [new TextRun({ text: "ENDEREÇO DO ESTABELECIMENTO", bold: true })],
                shading: {
                  type: ShadingType.HORIZONTAL_CROSS,
                  color: "dadfe1",
                  fill: "dadfe1",
                },
                spacing: {
                  before: 30,
                  after: 30,
                },
              }),
              new Paragraph({
                children: [new TextRun({ text: "Logradouro, No: " }), new TextRun({ text: this.modalCustomSizeData.relatorio.endereco ? this.modalCustomSizeData.relatorio.endereco : "", allCaps: true, size: 24, type: WidthType.DXA })],
                spacing: {
                  after: 10,
                },
              }),
              new Paragraph({
                children: [new TextRun({ text: "Bairro: " }), new TextRun({ text: this.modalCustomSizeData.relatorio.bairro ? this.modalCustomSizeData.relatorio.bairro : "", allCaps: true, size: 24, type: WidthType.DXA }), new TextRun({ text: "\t" }), new TextRun({ text: "Município / UF: " })],
                spacing: {
                  after: 10,
                },
              }),
              new Paragraph({
                children: [
                  new TextRun({ text: "Telefone: " }),
                  new TextRun({ text: this.modalCustomSizeData.relatorio.telefoneEmpresa ? this.modalCustomSizeData.relatorio.telefoneEmpresa : "", allCaps: true, size: 24, type: WidthType.DXA }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "Fax: " }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "E-mail: " }),
                  new TextRun({ text: this.modalCustomSizeData.relatorio.emailEmpresa ? this.modalCustomSizeData.relatorio.emailEmpresa : "", allCaps: true, size: 24, type: WidthType.DXA }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "CEP: " }),
                  new TextRun({ text: this.modalCustomSizeData.relatorio.cepEndereco ? this.modalCustomSizeData.relatorio.cepEndereco : null, allCaps: true, size: 24, type: WidthType.DXA }),
                ],
                spacing: {
                  after: 60,
                },
              }),
              //#endregion

              //#region CARACTERIZAÇÃO DO PROCEDIMENTO
              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [new TextRun({ text: "CARACTERIZAÇÃO DO PROCEDIMENTO", bold: true })],
                shading: {
                  type: ShadingType.HORIZONTAL_CROSS,
                  color: "dadfe1",
                  fill: "dadfe1",
                },
                spacing: {
                  before: 30,
                  after: 30,
                },
              }),
              new Paragraph({
                children: [
                  new TextRun({ text: "Origem do Procedimento: " }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "Início (Data): " }),
                  new TextRun({ text: this.modalCustomSizeData.relatorio.dataInicio ? this.modalCustomSizeData.relatorio.dataInicio : "", allCaps: true, size: 24, type: WidthType.DXA }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "Fim (Data): " }),
                  new TextRun({ text: this.modalCustomSizeData.relatorio.dataFim ? this.modalCustomSizeData.relatorio.dataFim : "", allCaps: true, size: 24, type: WidthType.DXA }),
                ],
                spacing: {
                  after: 30,
                },
              }),
              new Paragraph({
                text: "- Objetivo: ",
                spacing: {
                  after: 10,
                },
                border: bordaParagrafo,
              }),
              new Paragraph({ text: "" }),
              new Paragraph({ text: "" }),
              new Paragraph({
                text: "",
                spacing: {
                  after: 10,
                },
              }),
              new Paragraph({
                text: "- Relato da situação: ",
                spacing: {
                  after: 10,
                },
                border: bordaParagrafo,
              }),
              //#endregion
            ],
          },
        ],
      };

      this.modalCustomSizeData.relatorio.listaDeSetoresParaGerar.map((setores) => {
        let numeroSetor = 1;
        corpoDocx.sections[0].children.push(
          new Paragraph({
            alignment: AlignmentType.LEFT,
            children: [new TextRun({ text: "Setor " + numeroSetor + ":\t", bold: true }), new TextRun({ text: setores.setor.nomeSetor, bold: true, allCaps: true, size: 24, type: WidthType.DXA })],
            shading: {
              type: ShadingType.HORIZONTAL_CROSS,
              color: "dadfe1",
              fill: "dadfe1",
            },
            spacing: {
              before: 60,
              after: 60,
            },
          })
        );

        let numeroQuestao = 1;
        setores.listaQuestaoSetor.map((questoes) => {
          corpoDocx.sections[0].children.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [new TextRun({ text: "Questão " + numeroQuestao + ": ", bold: true }), new TextRun({ text: questoes.questao.nomeQuestao, size: 24, type: WidthType.DXA })],
              spacing: {
                before: 60,
                after: 30,
              },
            })
          );

          questoes.listaAlternativa.map((alternativas) => {
            if (alternativas.alternativa.tipoAlternativa == 0) {
              if (alternativas.alternativa.nomeAlternativa === questoes.respostaQuestao.descricaoResposta) {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: "(X) " + alternativas.alternativa.nomeAlternativa, bold: true, size: 24, type: WidthType.DXA })],
                  })
                );
              } else {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: "( ) " + alternativas.alternativa.nomeAlternativa, size: 22, type: WidthType.DXA })],
                  })
                );
              }
            }

            if (alternativas.alternativa.tipoAlternativa == 1) {
              if (alternativas.respostaAlternativa.descricaoResposta) {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: "[X] " + alternativas.alternativa.nomeAlternativa, bold: true, size: 24, type: WidthType.DXA })],
                  })
                );
              } else {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: "[ ] " + alternativas.alternativa.nomeAlternativa, size: 22, type: WidthType.DXA })],
                  })
                );
              }
            }

            if (alternativas.alternativa.tipoAlternativa == 2) {
              if (alternativas.respostaAlternativa.descricaoResposta) {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: alternativas.alternativa.nomeAlternativa + " " + alternativas.respostaAlternativa.descricaoResposta, size: 24, type: WidthType.DXA })],
                  })
                );
              } else {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: alternativas.alternativa.nomeAlternativa, size: 22, type: WidthType.DXA })],
                  })
                );
              }
            }
          });

          corpoDocx.sections[0].children.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [new TextRun({ text: questoes.respostaQuestao.observacao ? "Observação: " + questoes.respostaQuestao.observacao : "", size: 24, type: WidthType.DXA })],
              spacing: {
                after: 60,
              },
            })
          );

          numeroQuestao++;
        });

        numeroSetor++;
      });

      Packer.toBlob(new Document(corpoDocx)).then((blob) => {
        fs.saveAs(blob, this.modalCustomSizeData.relatorio.razaoSocial + ".docx");
      });
    },
    //#endregion

    formataDataBanco(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);

        return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
      } else {
        return null;
      }
    },

    _formatStringInBrazilianDateFormat(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);
        return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
      } else {
        return "Sem Data";
      }
    },

    seleciona() {
      this.todosSelecionado = false;
    },

    selecionaTodos() {
      this.modalCustomSizeData.relatorio.listaDeSetoresParaGerar = [];

      if (this.todosSelecionado) {
        this.modalCustomSizeData.relatorio.listaDeSetoresParaGerar = this.modalCustomSizeData.relatorio.listaSetores;
      }
    },
  },
};
</script>
